import React from 'react';
import { Rocket } from 'lucide-react';

const OurStory = () => {
  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-5xl mx-auto">
        <div className="space-y-8">
          <div className="flex items-center space-x-4">
            <div className="inline-block p-3 bg-blue-50 rounded-lg">
              <Rocket className="w-10 h-10 text-blue-600" />
            </div>
            <h2 className="text-4xl sm:text-5xl font-bold text-gray-900">
              Our <span className="text-blue-600">Story</span>
            </h2>
          </div>
          
          <p className="text-lg text-gray-600 leading-relaxed">
            Emerging from the continuous growth of the Norwegian startup studio Ymir in 2023, Upscale embodies years of insights gained through the establishment and expansion of startups in Norway, India, and the UK.
          </p>
          
          <p className="text-lg text-gray-600 leading-relaxed">
            Founded by the adept growth hacker, Arjun Bhatt, Upscale is dedicated to assisting startups in overcoming distinctive growth challenges, specifically in the realms of acquiring and engaging early adopters.
          </p>
          
          <p className="text-lg text-gray-600 leading-relaxed">
            The Upscale team boasts extensive experience collaborating with global startups and scale-ups at various stages of their journey, spanning from strategic planning and product development to launch and company scaling.
          </p>
        </div>
      </div>
    </section>
  );
};

export default OurStory;